import { createSlice } from "@reduxjs/toolkit";

export const commonSlice = createSlice({
  name: "common",
  initialState: {
    profileId: "",
    duns: "",
    externalVendorEmail: "",
    vendorCorpName: "",
    vendorConnectionPlatform: "",
    vendorPhone: "",
    boardingStatuses: {},
    vendorMenuItems: [],
    mandatoryDocStatusRes: false,
    mandatoryDocRes: {},
    documentList: [],
    configValues: [],
    vendorHasDeleted: false,
  },
  reducers: {
    updateCommonInfo: (state, { payload }) => ({ ...state, ...payload }),
    updateVendorCommonStatus: (state, { payload }) => ({
      ...state,
      boardingStatuses: {
        ...state.boardingStatuses,
        ...payload,
      },
    }),
    resetCommonSliceData: (state, action) => ({
      ...state,
      profileId: "",
      externalVendorEmail: "",
      vendorCorpName: "",
      duns: "",
      vendorConnectionPlatform: "",
      vendorPhone: "",
      boardingStatuses: {},
      vendorMenuItems: [],
      mandatoryDocStatusRes: false,
      mandatoryDocRes: {},
      documentList: [],
      configValues: [],
    }),
  },
});

export const {
  updateCommonInfo,
  updateVendorCommonStatus,
  resetCommonSliceData,
} = commonSlice.actions;
export default commonSlice.reducer;
